import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App, { preloadRoute } from './App';
import siteRoutes from './siteRoutes';

// Hand the route list to scripts/prerender.js (headless Chrome only).
if (navigator.webdriver) {
  window.__SITE_ROUTES__ = siteRoutes;
}

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// scripts/prerender.js writes fully-rendered HTML into build/<route>.html.
// Load the current page's chunk first, then hydrate: React adopts the
// prerendered DOM instead of rebuilding it, so the content that is already
// on screen stays put (fast LCP, no flash). If the markup ever differs,
// React recovers by client-rendering, which is what a plain render did.
preloadRoute(window.location.pathname)
  .catch(() => {})
  .then(() => {
    if (container.hasChildNodes()) {
      ReactDOM.hydrateRoot(container, app);
    } else {
      ReactDOM.createRoot(container).render(app);
    }
  });
